import { render, staticRenderFns } from "./page-content-header.vue?vue&type=template&id=53f3ab90&scoped=true"
import script from "./page-content-header.vue?vue&type=script&lang=js"
export * from "./page-content-header.vue?vue&type=script&lang=js"
import style0 from "./page-content-header.vue?vue&type=style&index=0&id=53f3ab90&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53f3ab90",
  null
  
)

export default component.exports